<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="115px">
        <el-row :gutter="24">
          <!-- <el-col :span="12">
            <el-form-item label="养老院名称" prop="nursinghomeId">
              <el-select
                disabled
                v-model="form.nursinghomeId"
                style="width: 100%"
                placeholder="请选择养老院名称"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in nursinghomeIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <h4>基本信息</h4>
          </el-col>
          <el-col :span="8">
            <el-form-item label="活动主题名称" prop="theme">
              <el-input
                :disabled="model === 'view' || editDisabled"
                clearable
                v-model="form.theme"
                placeholder="请输入活动主题名称"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="副标题" prop="subtitle">
              <el-input
                :disabled="model === 'view' || editDisabled"
                clearable
                v-model="form.subtitle"
                placeholder="请输入副标题"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="活动分类" prop="activityType">
              <el-select
                :disabled="model == 'view' || editDisabled"
                v-model="form.activityType"
                style="width: 100%"
                placeholder="请选择活动分类"
              >
                <el-option
                  v-for="(item, index) in activityTypeList"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="活动时间" prop="activityTimeRange">
              <el-date-picker
                :disabled="model === 'view' || editDisabled"
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                v-model="form.activityTimeRange"
                type="datetimerange"
                start-placeholder="请选择开始时间"
                end-placeholder="请选择结束时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="活动地点" prop="activityAddress">
              <el-input
                :disabled="model === 'view' || editDisabled"
                clearable
                v-model="form.activityAddress"
                placeholder="请输入活动地点"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="详细地址" prop="address">
              <el-input
                :disabled="model === 'view' || editDisabled"
                clearable
                v-model="form.address"
                placeholder="请输入详细地址"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="活动举办单位" prop="holdDeptId">
              <avue-input-tree
                ref="treeselect"
                :disabled="model === 'view' || editDisabled"
                style="width:100%"
                :props="treeDeptProps"
                v-model="form.holdDeptId"
                placeholder="请选择活动举办单位"
                type="tree"
                :dic="deptList"
              ></avue-input-tree>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="活动负责人" prop="holdPersonId">
              <choice-people
                ref="choicePeopleRef"
                :limit="1"
                :allUserList="realInspectManList"
                :list="deptObj"
                :disabled="model === 'view' || editDisabled"
                :remainUserListInside.sync="realInspectManList"
                :projectId="form.projectId"
                placeholder="请选择活动负责人"
              ></choice-people>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话" prop="phone">
              <el-input
                disabled
                clearable
                v-model="form.phone"
                placeholder="请输入联系电话"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="活动内容简述" prop="resume">
              <el-input
                :disabled="model === 'view' || editDisabled"
                v-model="form.resume"
                maxlength="500"
                type="textarea"
                placeholder="请输入内容简述"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="排序" prop="sort">
              <el-input-number
                :disabled="model === 'view' || editDisabled"
                v-model="form.sort"
                :controls="false"
                :min="1"
                :max="999999999999"
                label="请输入排序"
                :style="{ width: '100%' }"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="报名时间区间" prop="participateTimeRange">
              <el-date-picker
                :disabled="model === 'view' || editDisabled"
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                v-model="participateTimeRange"
                type="datetimerange"
                start-placeholder="请选择开始时间"
                end-placeholder="请选择结束时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="报名人数限额" prop="registerLimit" :rules="participateNumRule">
              <el-input-number
                :disabled="model === 'view' || editDisabled"
                v-model="form.registerLimit"
                :controls="false"
                :min="0"
                :precision="0"
                :max="999999999999"
                label="请输入报名人数限额"
                :style="{ width: '100%' }"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="活动宣传图片" prop="attachList">
              <vUpload
                :disabled="model === 'view' || editDisabled"
                :message="'提示：上传文件不大于12MB，数量最多3张'"
                :types="['doc', 'docx', 'ppt', 'pptx', 'txt', 'xlsx', 'xls', 'pdf', 'jpg', 'png']"
                :max="12 * 1024 * 1024"
                :limit="3"
                :fileList.sync="form.attachList"
              ></vUpload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="活动详情" prop="activityContent">
              <VueEditor
                id="editor"
                :disabled="model === 'view' || editDisabled"
                v-model="form.activityContent"
                useCustomImageHandler
                @image-added="handelRichTextImageAdded"
              ></VueEditor>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <h4>活动人员（{{form.personList.length }}）</h4>
          </el-col>
          <el-col :span="24">
            <el-button
              v-if="model != 'view'"
              type="primary"
              icon="el-icon-circle-plus-outline"
              :disabled="!dicFieldsDone"
              @click="addPeople"
              size="small"
            >
              新增
            </el-button>
            <el-table v-if="dicFieldsDone" :data="form.personList" style="width: 100%">
              <el-table-column prop="name" label="人员姓名" width="180"> </el-table-column>
              <el-table-column prop="phone" label="联系方式" width="180"> </el-table-column>
              <el-table-column prop="registerTime" label="报名时间"> </el-table-column>
              <el-table-column prop="remark" label="备注"> </el-table-column>
              <template v-for="(item, itemKey, index) in dicFields">
                <el-table-column :key="itemKey" :prop="itemKey" :label="item.dictValue"> </el-table-column>
              </template>
              <el-table-column prop="" label="">
                <template slot-scope="scope" v-if="model != 'view'">
                  <el-button type="text" @click="editPeople(scope.row)">编辑</el-button>
                  <el-button type="text" @click="delPeople(scope)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
    <hr-dialog
      :title="formModel === 'add' ? '新增' : formModel === 'edit' ? '编辑' : '查看'"
      :allowFull="false"
      width="60%"
      :visible.sync="activePeopleVisible"
    >
      <template slot="body">
        <acticePeopleForm
          :model="formModel"
          :row="formRow"
          :dicFields="dicFields"
          @cancle="recordCancle"
          v-if="activePeopleVisible"
          @submit="getActivePeople"
        ></acticePeopleForm>
      </template>
    </hr-dialog>
  </div>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import { VueEditor } from 'vue2-editor/dist/vue2-editor.core.js';
import vUpload from '../components/mutil-upload.vue';
import choicePeople from '@/components/user-edit-box/user-edit-box3';
import acticePeopleForm from './acticePeopleForm.vue';
import {
  treeByIds,
  activityManageSave,
  activityManageDetail,
  activityManageUpdate,
  getAuxField,
} from '@/api/goldHousekeep/index';
import { putFile } from '@/api/crmedical/contract/add';
import { loadRoomTree1 } from '@/api/charge/charge-pay';

export default {
  components: { vUpload, acticePeopleForm, choicePeople },
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      communityList: [],
      formRow: {},
      deptObj: {},
      activityTypeList: [],
      realInspectManList: [],
      projectList: [],
      activePeopleVisible: false,
      treeDeptProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      form: {
        theme: '',
        activityAddress: '',
        holdPersonName: '',
        holdPersonId: '',
        holdDeptId: '',

        projectType: '1',
        subtitle: '',
        activityType: '',
        activityStartTime: '',
        activityTimeRange: [],
        address: '',
        activityEndTime: '',
        phone: '',
        resume: '',
        sort: '',
        activityContent: '',
        attachList: [],
        personList: [],
        registerLimit: undefined,
      },
      formRules: {
        activityAddress: [{ required: true, message: '活动地点不能为空', trigger: 'change' }],
        theme: [{ required: true, message: '主题不能为空', trigger: 'blur' }],
        activityType: [{ required: true, message: '活动分类不能为空', trigger: 'change' }],
        holdPersonId: [{ required: true, message: '举办人不能为空', trigger: 'change' }],

        activityTimeRange: [{ required: true, message: '活动时间不能为空', trigger: 'change' }],
        activityContent: [{ required: true, message: '活动详情不能为空', trigger: 'change' }],
        sort: [{ required: true, message: '排序不能为空', trigger: 'change' }],
        attachList: [{ required: true, message: '活动宣传图片不能为空', trigger: 'change' }],
      },
      matetialList: [],
      nursinghomeIdList: [],
      userList: [],
      // 报名时间区间
      participateTimeRange: [],
      participateNumRule: [],
      // 自定义字典字段
      dicFieldsArr: ['join_community', 'register_project'],
      dicFields: {},
      dicFieldsDone: false
    };
  },
  computed: {
    editDisabled() {
      return this.row.pushStatus == 1 && this.model == 'edit'
    },
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {
    realInspectManList: {
      handler() {
        if (this.realInspectManList.length > 0) {
          console.log(this.realInspectManList[0]);
          this.$set(this.form, 'holdPersonId', this.realInspectManList[0].id);

          this.form.holdPersonName = this.realInspectManList[0].realName;
          this.form.phone = this.realInspectManList[0].phone;
          this.$forceUpdate();
        }
      },
      immediate: true,
      deep: true,
    },
    participateTimeRange: {
      handler(val) {
        console.log('participateTimeRange---', val)
        if (val && val.length) {
          this.participateNumRule = [{ required: true, message: '报名人数不能为空', trigger: 'change' }];   
        } else {
          this.participateNumRule = [];
          this.$refs.formRef && this.$refs.formRef.clearValidate(['registerLimit'])
        }
        console.log('this.participateNumRule', this.participateNumRule)
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    delPeople(scope) {
      console.log(scope);
      this.form.personList.splice(scope.$index, 1);
    },
    getActivePeople(data) {
      this.form.personList.push(data);
      this.activePeopleVisible = false;
    },
    addPeople() {
      this.formModel = 'add';
      this.activePeopleVisible = true;
    },
    recordCancle() {
      this.activePeopleVisible = false;
    },
    editPeople(row) {
      this.formModel = 'edit';
      this.formRow = row;
      this.activePeopleVisible = true;
    },
    handelRichTextImageAdded(file, Editor, cursorLocation, resetUploader) {
      if (this.formMode == 'view') return;
      var formData = new FormData();
      formData.append('file', file);
      // 通过上传接口返回url，将url放入富文本编辑器中
      putFile(formData)
        .then((res) => {
          let url = res.data.link;
          Editor.insertEmbed(cursorLocation, 'image', url);
          resetUploader();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async initData() {
      loadRoomTree1().then(({ data }) => {
        this.communityList = data;
      });

      getDictionary('nursinghome_activity_type').then((res) => {
        this.activityTypeList = res.data;
      });
      treeByIds().then((res) => {
        this.deptList = res.data;
        if (res.data.length > 0) {
          this.deptObj = res.data[0];
        }
      });
      if (this.model === 'add') {
      } else {
        activityManageDetail({ id: this.row.id }).then((res) => {
          console.log('**------**', res.data);
          this.form = res.data;
          //   console.log("**------**",res.data)
          this.form.activityTimeRange = [this.form.activityStartTime, this.form.activityEndTime];
          if (this.form.registerStartTime && this.form.registerEndTime) {
            this.participateTimeRange = [this.form.registerStartTime, this.form.registerEndTime];
          }          
          let obj = {
            id: this.form.holdPersonId,
            realNameAndPhone: this.form.holdPersonName,
            realName: this.form.holdPersonName,
            phone: this.form.phone,
          };
          this.realInspectManList.push(obj);
          //   console.log("****",this.form)
        });
      }
      const prmLst = []
      // 获取自定义的字典字段
      this.dicFieldsArr.forEach(item => { 
        prmLst.push(getAuxField({ code: item }))
      })
      Promise.all(prmLst).then(res => {
        console.log('dicFieldsArr-res', res)
        res.forEach((item) => {
          const { data } = item
          // 字典的项
          const fieldO = data.find(f => f.parentId == 0)
          if (fieldO) {
            const k = this.tool.convertToCamelCase(fieldO.code)
            const list = data.filter(f => f.parentId != 0)
            fieldO.options = list
            this.dicFields[k] = fieldO
          }
        })
        this.dicFieldsDone = true
      })
    }, 
    saveRecord() {
      if (this.form.elderlyIds_ && this.form.elderlyIds_.length > 0) {
        this.form.elderlyIds = this.form.elderlyIds_.join(',');
      }
      if (this.form.activityTimeRange && this.form.activityTimeRange.length > 0) {
        this.form.activityStartTime = this.form.activityTimeRange[0];
        this.form.activityEndTime = this.form.activityTimeRange[1];
      } else {
        this.form.activityStartTime = '';
        this.form.activityEndTime = '';
        this.form.activityTimeRange = [];
      }
      // 处理报名区间时间
      if (this.participateTimeRange && this.participateTimeRange.length > 0) {
        this.form.registerStartTime = this.participateTimeRange[0];
        this.form.registerEndTime = this.participateTimeRange[1];
      } else {
        this.form.registerStartTime = '';
        this.form.registerEndTime = '';
        this.participateTimeRange = [];
      }
      if (this.model === 'add') {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            activityManageSave(this.form).then((res) => {
              this.$message.success('新增成功');
              this.$emit('success');
            });
          }
        });
      } else {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            activityManageUpdate(this.form).then((res) => {
              this.$message.success('修改成功');
              this.$emit('success');
            });
          }
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
